import { BaseMapper } from '@ps/utils';

import { Tag } from '@ps/feature-tags';
import { TagDto } from '../dtos/tag.dto';

export class TagMapper extends BaseMapper<TagDto, Tag> {
  public fromDto(dto: TagDto): Tag {
    return {
      id: dto.id,
      label: dto.label,
      emoji: dto.emoji,
      description: dto.description,
      status: dto.status,
      isGlobal: dto.isGlobal,
    };
  }
}
